import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../../scss/app.scss';
import { userManagerPromise } from "../../oidc/userManager";

class Authenticate extends Component {
    componentDidMount() {
        if (window.location.href.indexOf('#') === -1 && window.location.href !== '/') {
            // If it doesn't contain # and only contains '/' don't store
            localStorage.setItem('originalUrl', window.location.pathname + window.location.search);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { isLoading } = this.props;

        if (!isLoading && prevProps.isLoading) {
            const { user } = this.props;
            if (!user || user.expired) {
                userManagerPromise.then((userManager) => {
                    userManager.signinRedirectCallback()
                        .then((user) => {
                            window.location.href = localStorage.getItem('originalUrl');
                        })
                        .catch((error) => {
                            userManager.signinRedirect();
                        });
                });
            }
        }
    }

    render() {
        return (
            <React.Fragment />
        );
    }
}

export default connect(
    state => ({
        user: state.oidc.user,
        isLoading: state.oidc.isLoadingUser
    }),
    dispatch => ({})
)(Authenticate);



// WEBPACK FOOTER //
// /src/components/framework/Authenticate.js